import React, { Component } from 'react';
import './StoreBanner.css'

declare var $;
declare var ScrollMagic;

class StoreBanner extends Component {
   constructor(props) {
     super(props)

   }

   componentDidMount() {
         $(".button-collapse").sideNav();
   }

  render() {
    var divImage = {
       backgroundImage : "url(assets/img/bgstore.png)"
     };
    return (

      <div>
      <header>
          <nav>
           <div className="nav-wrapper">
             <a href="#!" className="brand-logo center"><img src="assets/img/logo.png" alt=""/></a>
             <a href="#" data-activates="mobile-demo" className="button-collapse"><i className="material-icons">menu</i></a>
           </div>
          </nav>
       <ul className="side-nav" id="mobile-demo">
          <li><img src="assets/img/logo-rappi.png"/></li>
          <li><a className="waves-effect  waves-green" href="badges.html"> <img src="assets/img/googleplay.png"/>  Google Play</a></li>
          <li><a className="waves-effect  waves-green" href="collapsible.html"> <img  className="apple" src="assets/img/appstore.png"/>  App Store</a></li>
          <li><a  className="waves-effect  waves-green" href="mobile.html">www.rappi.com</a></li>
          <li><div className="divider"></div></li>
          <li><a className="waves-effect waves-green">Pedir ya!</a></li>
        </ul>
      </header>
      <section className="intro">
        <div id="background" style={divImage}>
          <div className="center">
            <h1>{this.props.copy}</h1>
            <p> {this.props.subcopy}</p>
          </div>
        </div>
      </section>

      </div>


    /*  <section id="intro" style={sectionStyle}>
      <div id="background" style={divImage}></div>
      <div className="container">
        <div className="row">
          <div className="col-md-12 intro-img intro-store text-center">
            <div className="images">
              <img  className="img animated slideInLeft" src="assets/img/naranja.png"></img>
              <img className="img animated slideInDown" src="assets/img/kiwi.png"></img>
              <img className="img animated slideInUp" src="assets/img/granada.png"></img>
            </div>
            <h1>{this.props.copy}</h1>
            <p> {this.props.subcopy}</p>
          { this.props.coupon_code && <span> ENVIO GRATIS </span> }
          </div>
        </div>
      </div>
     </section> */
    );
  }

}


export default StoreBanner;



// WEBPACK FOOTER //
// ./src/components/store-banner/StoreBanner.js